export const capitalizeFirstLetter = (s: string): string => {
  return !s ? s : s.charAt(0).toUpperCase() + s.slice(1)
}
